function defaultValue(a, b) {
	if (a !== undefined && a !== null) {
		return a;
	}
	return b;
}
function serviceConfigToken(Config) {
	let tokenStr = '';
	if (Config) {
		if (Config.tokenKey && Config.tokenValue) {
			tokenStr = `${Config.tokenKey}=${Config.tokenValue}`;
		}
	}
	return tokenStr;
}
function serviceConfigRequestInterceptors(Config, url) {
	url = defaultValue(url, '');
	if (!Config || !Config.request || !Config.request.interceptors) {
		return url;
	}
	const requestInterceptors = Config.request.interceptors;
	const _urlOrigin = decodeURI(url);
	if (requestInterceptors && requestInterceptors instanceof Array) {
		let _beforeUrl = '';
		for (let i = 0; i < requestInterceptors.length; i++) {
			const urls = requestInterceptors[i].urls;
			const before = requestInterceptors[i].before;
			// 不存在urls，则应用到全部url上
			if (!urls) {
				if (before && before instanceof Function) {
					const _before = before(url);
					if (_before) {
						_beforeUrl += _before;
					}
				}
			} else if (typeof urls === 'string') {
				const _url = decodeURI(urls);
				if (_urlOrigin.indexOf(_url) > -1) {
					if (before && before instanceof Function) {
						const _before = before(url);
						if (_before) {
							_beforeUrl += _before;
						}
					}
				}
			} else if (urls instanceof Array) {
				for (let j = 0; j < urls.length; j++) {
					const _url = decodeURI(urls[j]);
					if (_urlOrigin.indexOf(_url) > -1) {
						if (before && before instanceof Function) {
							const _before = before(url);
							if (_before) {
								_beforeUrl += _before;
							}
						}
					}
				}
			}
			if (_beforeUrl) {
				url = _beforeUrl;
			}
		}
	}
	return url;
}

function serviceConfigResponseInterceptors(Config, url, img) {
	url = defaultValue(url, '');
	if (!Config || !Config.request || !Config.request.interceptors) {
		return url;
	}
	const requestInterceptors = Config.request.interceptors;
	const _urlOrigin = decodeURI(url);
	if (requestInterceptors && requestInterceptors instanceof Array) {
		for (let i = 0; i < requestInterceptors.length; i++) {
			const urls = requestInterceptors[i].urls;
			const after = requestInterceptors[i].after;
			// 不存在urls，则应用到全部url上
			if (!urls || (urls instanceof Array && urls.length === 0)) {
				if (after && after instanceof Function) {
					const _after = after(img);
					if (_after) {
						return _after;
					}
				}
			} else if (typeof urls === 'string') {
				const _url = decodeURI(urls);
				if (_urlOrigin.indexOf(_url) > -1) {
					if (after && after instanceof Function) {
						const _after = after(img);
						if (_after) {
							return _after;
						}
					}
				}
			} else if (urls instanceof Array) {
				for (let j = 0; j < urls.length; j++) {
					const _url = decodeURI(urls[j]);
					if (_urlOrigin.indexOf(_url) > -1) {
						if (after && after instanceof Function) {
							const _after = after(img);
							if (_after) {
								return _after;
							}
						}
					}
				}
			}
		}
	}
	return img;
}
export {
	serviceConfigToken,
	serviceConfigRequestInterceptors,
	serviceConfigResponseInterceptors,
};
